import moment from 'moment'
import {
  customParse,
  fetchCurrentSalesOrder,
  formatDigits,
  getDecryptID,
  isEmptyObject
} from '../appRedux/actions'
import { checkNameNSpaces } from '../appRedux/actions/PrintHelper'
import {  PRINT_CASH_MOVE_TYPES, PRINT_CONST_FOOTER_1, PRINT_CONST_FOOTER_2, PRINT_TYPES } from '../constants/StoreSetting'
import { env } from '../env'

const { REACT_APP_PRINT_CONST_FOOTER_3 } = env

// NOTE: # esc printer commands
// \t --> tab
// \x1B\x45\x01 --> bold
// \x1B\x45\x00 --> normal text
// \x1D\x56\x42\x00 --> paper cut // or --> \x1d\x56\x00
// \x1Ba\x00 --> To left-align a text // or --> \x1B\x61\x00
// \x1B\x61\x01 --> center // or --> \x1Ba\x01
// \x1Ba\x02 --> To left-align a text // or --> \x1B\x61\x02

export function getPrintStringForReceipt (data, currency, dec) {
  try {
    if (data) {
      
      const decimal = dec ? dec : 2
      const prodMaxLength = 20
      const taxMaxLength = 6
      const payMaxLength = 12
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')
      let prods = ''
      let pays = ''
      let taxesDiv = ''
      data.taxesSum &&
        data.taxesSum.length > 0 &&
        data.taxesSum.map((e, keyy) => {
          let end = data.taxesSum.length == keyy + 1
          if (e.saleTaxName) {
            let taxVal = e.taxPrice ? `${currency} ${e.taxPrice}` : ''
            let checkAcc =
              getDecryptID(data.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('On Account, completed')) ||
              getDecryptID(data.sSalesOrderStatusID) ==
                getDecryptID(fetchCurrentSalesOrder('Layby, completed'))
            if (
              checkAcc &&
              data.salesOrderDiscountPrice &&
              data.salesOrderDiscountPrice != '0.00'
            ) {
              taxVal = ''
            }
            if (
              data.isRefundSale &&
              data.additionalDiscount &&
              data.additionalDiscount != ''
            ) {
              taxVal = ''
            }
            taxesDiv += `\t\x1B\x45\x01${e.saleTaxName}   (${
              e.isFix ? e.fixRate : e.taxValue
            } ${e.isFix ? ' FIX' : '%'})\t\x1B\x45\x00 ${taxVal}${
              end ? '' : '\n'
            }`
          }
        }).join('')
      let taxNbr =
        data.taxesSum && data.taxesSum.length > 0
          ? ` (${data.taxesSum.length} Taxes)`
          : ''
      let taxAmount = data.totalTax ? `${currency} ${data.totalTax}` : '0.00'
      let subtotal = data.totalPrice
        ? `${formatDigits(
            customParse(data.totalPrice) +
              (data.additionalDiscount && data.additionalDiscount != '0.00'
                ? customParse(data.additionalDiscount)
                : 0) -
              customParse(data.totalTax),
            2
          )}`
        : '0.00'
      let itemsNbr =
        data.totalItems && data.totalItems > 0
          ? ` (${data.totalItems} items)`
          : ``
      let totalAmount = data.totalPrice ? `${currency} ${data.totalPrice}` : ''
 
      let change = data.change ? parseFloat(data.change) : 0
      data &&
        data.products &&
        data.products.length > 0 &&
        data.products.map((e, key) => {
          prods += `\x1B\x61\x00${
            e.quantity ? `${parseInt(e.quantity)}  x  ` : ''
          }\x1B\x61\x01${
            e.productName ? e.productName : 'Prod Name'
          }\x1B\x61\x02${
            e.totalPriceReceipt ? e.totalPriceReceipt : '0.00'
          }\n    `
        }).join('')
      data.payments &&
        data.payments.length > 0 &&
        data.payments.map((pay, key) => {
          pays += `${pay.paymentName ? pay.paymentName : ''}  ${
            pay.paymentOn ? pay.paymentOn : ''
          }  ${currency} ${pay.amount}\n`
        }).join('')
      let subtotalhexa = `\x1B\x61\x00\x1B\x45\x01Subtotal:\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x00${currency}\x20${subtotal}`
      let additionalDishexa =data.additionalDiscount?`\x1B\x61\x00\x1B\x45\x01Additional Discount:\x20\x20\x20\x20\x1B\x45\x00${currency}\x20${data.additionalDiscount.includes('-')? data.additionalDiscount: data.additionalDiscount}`:''
      let head = ''
      if(data.showDate){
        head += `\x1B\x61\x01\x1B\x45\x01${today}\n`
      }
      if(data.showOutlet){
        head += `\x1B\x45\x01OUTLET:\x1B\x45\x00${data.outletName ? data.outletName : ''}\n`
      }
      if(data.showRegister){
        head += `\x1B\x45\x01REGISTER:\x1B\x45\x00${data.mainRegister ? data.mainRegister : ''}\n`
      }
      if(data.showServedBy){
        head += `\x1B\x45\x01SERVED BY: \x1B\x45\x00${data && data.soldBy ? data.soldBy : ''}\n`
      }
      let title = `\x1B\x61\x01${data.subtitle1}\n`
      if(data.subtitle1){
        title += `\x1B\x61\x01${data.subtitle1}\n`
      }
      if(data.subtitle2){
        title += `\x1B\x61\x01${data.subtitle2}`
      }
        // subtotalhexa = data.additionalDiscount
      //   ? subtotalhexa +
      //     `\n\x1B\x61\x00\x1B\x45\x01Additional Discount:   \x1B\x61\x02${currency} ${
      //       data.additionalDiscount.includes('-')
      //         ? data.additionalDiscount
      //         : data.additionalDiscount
      //     }`
      //   : subtotalhexa
      return `\x1D\x56\x42\x00\n\x1B\x61\x01${
        data.hheader ? data.hheader : ''
      }
    ${title}
    ${head}
    \x1B\x45\x01Receipt: \x1B\x45\x00${data.receipt ? data.receipt : ''}
    \x1B\x61\x01------- ${data && data.isRepeat ? ' **REPRINT** ' : ''} ${data && data.isRefundSale ? '--- Refund ' : ''} --------

    \x1B\x61\x00\x1B\x45\x01Quantity\x20\x20\x20\x20\x20\x1B\x45\x01Product Name\x20\x20\x20\x20\x20\x1B\x45\x01Price(${currency})
    ${data &&
      data.products &&
      data.products.length > 0 &&
      data.products.map((e, key) => {
        let pprodOrVariant = e.variantName ? e.variantName : e.productName
        let proddName = checkNameNSpaces(pprodOrVariant, prodMaxLength) // pprodOrVariant ? pprodOrVariant.length > prodMaxLength ? pprodOrVariant.substring(0, prodMaxLength - 3).concat('...') : pprodOrVariant.length < prodMaxLength ? pprodOrVariant.padEnd(prodMaxLength, " ").replace(/\s/g, '\x20') : pprodOrVariant : 'Prod Name'
        let row = ` \n \x1B\x45\x01\x20\x20\x20\x20${e.quantity ? `${parseInt(e.quantity)}  x ` : ''}\x1B\x45\x00 ${proddName}\x20\x1B\x45\x00${e.totalPriceReceipt ? e.totalPriceReceipt : '0.00'} \n`
        if(e.salesItemDiscount && customParse(e.salesItemDiscount) > 0){
          row += `\x20\x20\x20\x20\x20\x20Was: ${currency} ${formatDigits(customParse(e.totalPriceReceipt / e.quantity) + customParse(e.salesItemDiscount), decimal)} 
          Disc: ${e.discountPercentage}% /  ${currency} ${formatDigits(e.salesItemDiscount, decimal)}\n`
        }
        else if(e.promotions && !isEmptyObject(e.promotions) && e.promotions.promotionName && e.promotions.promotionName != ""){
          row += `\x20\x20\x20\x20\x20\x20Promotion: ${e.promotions.promotionName} (${e.promotionPercent ? `${e.promotionPercent}% / ` : ""} ${currency}
            ${e.promotions.promotionValue ? formatDigits(e.promotions.promotionValue / e.quantity, decimal) : "0.00"} off)\n`
        }
        else if(e.priceBookValue && customParse(e.priceBookValue) > 0){
          row += `\x20\x20\x20\x20\x20\x20Disc: (${e.priceBookPercent ? `${e.priceBookPercent}%  / ` : ""} ${currency} ${formatDigits(e.priceBookValue / e.quantity, decimal)} off)\n`
        }
        return row
      }).join('')}
    \x1B\x61\x01---------------------------------

    ${subtotalhexa}
    ${additionalDishexa}
    \x1B\x61\x00\x1B\x45\x01Total Tax\x1B\x45\x00 ${taxNbr}:\x20\x20\ ${taxAmount}
    ${ data.taxesSum &&
      data.taxesSum.length > 0 &&
      data.taxesSum.map((e, keyy) => {
        let end = data.taxesSum.length == keyy + 1
        if (e.saleTaxName) {
          let taxVal = e.taxPrice ? `${currency} ${e.taxPrice}` : ''
          let checkAcc =
            getDecryptID(data.sSalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('On Account, completed')) ||
            getDecryptID(data.sSalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('Layby, completed'))
          if (
            checkAcc &&
            data.salesOrderDiscountPrice &&
            data.salesOrderDiscountPrice != '0.00'
          ) {
            taxVal = ''
          }
          if (
            data.isRefundSale &&
            data.additionalDiscount &&
            data.additionalDiscount != ''
          ) {
            taxVal = ''
          }
          return `\n\x20\x20\x20\x1B\x45\x01 ${checkNameNSpaces(e.saleTaxName, taxMaxLength)}(${e.isFix ? e.fixRate : e.taxValue } ${e.isFix ? ' FIX' : '%'})\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x00 ${taxVal}`
        }
      }).join('')}
    
    \x1B\x61\x00\x1B\x45\x01Total ${itemsNbr}:\x20\x20\x20\x20\x20\x20 ${totalAmount}

    \x1B\x61\x00Payment Through:
    ${data.payments &&
      data.payments.length > 0 &&
      data.payments.map((pay, key) => {
        return `\n\x20\x20\x20\x20\x20\x1B\x61\x00${pay.paymentName ? checkNameNSpaces(pay.paymentName, payMaxLength) : ''}\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20${currency} ${pay.amount}\n\x20\x20\x20\x20\x20\x20\x20\x20${pay.paymentOn ? pay.paymentOn : ''}`}).join('')}
    \x1B\x61\x01---------------------------------
    ${change && change > 0 ? `\x1B\x61\x00\x1B\x45\x01CHANGE: \x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x00${currency} ${change}` : ''}
    ${data.Notes ? `\x1B\x61\x00\x1B\x61\x00NOTE:\x20\x20\x20\x20\x20${data.Notes}` : ''}
    ${data.ffooter ? `\x1B\x61\x01\x1B\x45\x01${data.ffooter}` : ''}
    
    \x1B\x61\x01\x1B\x45\x01${PRINT_CONST_FOOTER_1}
    \x1B\x61\x01${PRINT_CONST_FOOTER_2}
    \x1B\x61\x01${REACT_APP_PRINT_CONST_FOOTER_3}
    ${`\n\x1D\x56\x42\x00\n`}`
    }
  } catch (ex) {
   // console.log('print string error ====> ', ex)
  }
}

export function getPrintStringForOpenClose (data, currency, dec) {
  try {
    if (data) {
      const decimal = dec ? dec : 2
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')
      let title = ''
      if(data.subtitle1){
        title += `\x1B\x61\x01${data.subtitle1}\n`
      }
      if(data.subtitle2){
        title += `\x1B\x61\x01${data.subtitle2}`
      }
      const storeName = `\x1B\x61\x01\x1B\x45\x01${data.storeName ? data.storeName : ''}\n`
      const cashType = data.type && data.type == PRINT_TYPES.cashMove ? `${data.cashType == PRINT_CASH_MOVE_TYPES.CASH_IN
        ? 'CASH IN'
        : data.cashType ==
          PRINT_CASH_MOVE_TYPES.CASH_OUT
        ? 'CASH OUT'
        : data.cashType ==
          PRINT_CASH_MOVE_TYPES.PETTY_CASH_IN
        ? 'PETTY CASH IN'
        : data.cashType ==
          PRINT_CASH_MOVE_TYPES.PETTY_CASH_OUT
        ? 'PETTY CASH OUT'
        : ''}` : 
        data.type && data.type == PRINT_TYPES.opening ? 'Opening Float' : 
        ''
      let head = ``
      head += `\x1B\x61\x01\x1B\x45\x01${today}\n\x1B\x61\x01---------------------------------\n`
      head += `\x1B\x61\x01\x1B\x45\x01${cashType}\n`
      head += `\x1B\x61\x01\x1B\x45\x01${currency ? currency : ''}${data.amount ? formatDigits(data.amount, decimal) : '0.00'}\n`
      head += `\x1B\x61\x01---------------------------------\n`
      return `\x1d\x56\x00\x1D\x56\x42\x00\n\x1B\x61\x01${storeName}\n${
        data.hheader ? data.hheader : ''
      }
    ${title}
    ${head}
    \x1B\x61\x00\x1B\x45\x01\x1Ba\x02Outlet\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x01${data.outlet ? data.outlet : ''}
    \x1B\x61\x00\x1B\x45\x01\x1Ba\x02Register\x20\x20\x20\x20\x20\x1B\x45\x01${data.register ? data.register : ''}
    \x1B\x61\x00\x1B\x45\x01\x1Ba\x02Date\x20\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x01${data.date?  moment(data.date).format('l LT') : ''}
    \x1B\x61\x00\x1B\x45\x01\x1Ba\x02User\x20\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x01${data.user ? data.user : ''}
    \x1B\x61\x00\x1B\x45\x01\x1Ba\x02Note\x20\x20\x20\x20\x20\x20\x20\x20\x20\x1B\x45\x01${data.note ? data.note : ''}
    ${data.ffooter ? `\x1B\x61\x01\x1B\x45\x01${data.ffooter}` : ''}
    
    \x1B\x61\x01\x1B\x45\x01${PRINT_CONST_FOOTER_1}
    \x1B\x61\x01${PRINT_CONST_FOOTER_2}
    \x1B\x61\x01${REACT_APP_PRINT_CONST_FOOTER_3}
    ${`\n\x1d\x56\x00\x1D\x56\x42\x00\n`}`
    }
  } catch (ex) {
   // console.log('print string error ====> ', ex)
  }
}

export function getPrintStringForXZReport (data, currency, dec) {
  try {
    if (data) {
      const decimal = dec ? dec : 2
      const today =
        data && data.sellDate
          ? moment(data.sellDate).format('LLLL')
          : moment().format('LLLL')
      let title = `\x1B\x61\x01${data.subtitle1}\n`
      if(data.subtitle1){
        title += `\x1B\x61\x01${data.subtitle1}\n`
      }
      if(data.subtitle2){
        title += `\x1B\x61\x01${data.subtitle2}`
      }
      let storeName = `\x1B\x61\x01\x1B\x45\x01${data.storeName ? data.storeName : ''}\n`
      let head = ``
      head += `\x1B\x61\x01\x1B\x45\x01${data.outletName ? data.outletName : ''}\n`
      head += `\x1B\x61\x01\x1B\x45\x01${data.registerName ? data.registerName : ''}\n`
      head += `\x1B\x61\x01\x1B\x45\x01${today}\n\x1B\x61\x01---------------------------------\n`
      return `\x1d\x56\x00\x1D\x56\x42\x00\n\x1B\x61\x01${storeName}\n${
        data.hheader ? data.hheader : ''
      }
      ${title}
      ${head}
      ${data.showRefID ? `\x1B\x61\x00\x1B\x45\x01    \x20\x20\x20` : ''}\x20\x20\x1B\x45\x01Amount(${currency})\x20\x20${data.showSaleDate ? `\x20\x20\x20\x1B\x45\x01Date` : ''}
      ${data &&
        data.sales &&
        data.sales.length > 0 ?
        data.sales.map((e, key) => {
          let kkey = key + 1
          let amountt = e.amount
          ? `${currency}${e.amount} ${
              getDecryptID(e.salesOrderStatusID) ===
              getDecryptID(fetchCurrentSalesOrder('Voided'))
                ? '(Void)'
                : ''
            }`
          : ''
          let row = ` \n ${data.showRefID ? `\x1B\x45\x01\x20\x20\x20\x20${e.refID ? `${getDecryptID(e.refID)}` : ''}` : ''}\x1B\x45\x00 ${amountt}${data.showSaleDate ? `${e.date ? moment(e.date).format('l LT') : ''}` : ''} \n`
          if(false){ // data.showSaleDate
            row += `\x1B\x61\x01\x1Ba\x01${e.date ? moment(e.date).format('l LT') : ''}\n`
          }
          if(kkey < data.sales.length){
            row += `\x1B\x61\x01\x1Ba\x01${'-------'}\n`
          }
          return row
        }).join('') : `\x1B\x61\x01\x1B\x45\x01There are no sales`}
      \x1B\x61\x01\x1Ba\x01${'---------------------------------'}
      ${data.showTotalAmount ? `\x1B\x61\x00\x1Ba\x00\x1B\x45\x01Total Amount\x20\x20\x20\x20\x20\x1B\x45\x01${currency}${data.totalAmount ? data.totalAmount : '0.00'}` : ''}
      ${data.showTotalTax ? `\x1B\x61\x00\x1Ba\x00\x1B\x45\x01Total Tax\x20\x20\x20\x20\x20\x1B\x45\x01${currency}${data.totalTax ? data.totalTax : '0.00'}` : ''}
      \x1B\x61\x00\x1Ba\x00\x1B\x45\x01Total Void\x20\x20\x20\x20\x20\x1B\x45\x01${currency}${data.totalVoid ? data.totalVoid : '0.00'}
      ${data.ffooter ? `\x1B\x61\x01\x1B\x45\x01${data.ffooter}` : ''}
      
      \x1B\x61\x01\x1B\x45\x01${PRINT_CONST_FOOTER_1}
      \x1B\x61\x01${PRINT_CONST_FOOTER_2}
      \x1B\x61\x01${REACT_APP_PRINT_CONST_FOOTER_3}
      ${`\n\x1D\x56\x42\x00\n`}`
    }
  } catch (ex) {
   // console.log('print string error ====> ', ex)
  }
}

//NOTE: OUTLET REG WAGHERA
// \x1B\x61\x01\x1B\x45\x01${today}
//     \x1B\x45\x01OUTLET:\x1B\x45\x00${data.outletName ? data.outletName : ''}   
//     \x1B\x45\x01REGISTER:\x1B\x45\x00${data.mainRegister ? data.mainRegister : ''}
//     \x1B\x45\x01Receipt: \x1B\x45\x00${data && data.receipt ? `#${data.receipt}` : ''}
//     \x1B\x45\x01SERVED BY: \x1B\x45\x00${data && data.soldBy ? data.soldBy : ''}

// NOTE: sub total + additional discount
// \x1B\x61\x00\x1B\x45\x01Subtotal:   \x1B\x61\x02\x1B\x45\x00${currency} ${subtotal}
//     ${
//       data.additionalDiscount &&
//       `\x1B\x61\x00\x1B\x45\x01Additional Discount:   \x1B\x61\x02${currency} ${
//         data.additionalDiscount.includes('-')
//           ? data.additionalDiscount
//           : data.additionalDiscount
//       }`
//     }

// export function getPrintStringForReceipt (data) {
//   let result = ''
//   data = dataPrint
//   const today =
//     data && data.sellDate
//       ? moment(data.sellDate).format('LLLL')
//       : moment().format('LLLL')
//   if (data) {
//     let prods = '';
//     let pays = '';
//     let change = data.change ? parseFloat(data.change) : 0;
//     data && data.products && data.products.length > 0 && data.products.map((e, key) => {
//       prods += `        ${e.quantity ? ` (${e.quantity})` : ""}  ${e.productName ? e.productName : "Prod Name"}  @  EUR${e.totalPriceReceipt ? e.totalPriceReceipt : "0.00"}\n`;
//     });
//     data.payments && data.payments.length > 0 && data.payments.map((pay, key) => {
//       pays += `      ${pay.paymentName ? pay.paymentName : ""} ${pay.paymentOn ? pay.paymentOn : ""} EUR${pay.amount}`
//     });
//     result =
//     `         ${data.OutletName ? data.OutletName : ""}

//       ${today}

//       OUTLET: ${data.OutletName ? data.OutletName : ''}
//       REGISTER: ${data.MainRegister ? data.MainRegister : ''}
//       VAT Number: XXXXXXXXXX
//       Receipt: ${data && data.receipt ? `#${data.receipt}` : ''}
//       SERVED BY: ${data && data.soldBy ? data.soldBy : 'User'}

//       ---------${data && data.isRepeat ? ' **REPRINT** ' : ''}---${data && data.isRefundSale ? 'Refund' : ''}----------------

// ${prods}
//       ---------------------------------
//       Subtotal:             EUR 12.12
//       ${data.additionalDiscount ? `Additional Discount:   EUR ${data.additionalDiscount.includes("-") ? data.additionalDiscount : data.additionalDiscount}` : ""}
//       Total Tax (2 Taxes)   EUR 12.12
//         VAT (18 %)  EUR 2.00

//       Total (1 Items)       EUR 12.12

//       Payment Through:
// ${pays}

//       ---------------------------------
//       ${data.Notes ? `NOTE: ${data.Notes}` : ""}
//       ${change && change > 0 ? `Change:             EUR ${change}` : ""}
//       `
//   }
//   return result
// }
